import React from "react";
import { NavLink } from "react-router-dom";
import bigthink from "../img/NewLogo/Big_Think.svg";
const About_virtuos = () => {
  return (
    <section className="about-virtuos">
      <div
        className="lft-bg wow animated fadeInUp"
        data-wow-duration="1000ms"
        data-wow-delay="700ms"
      >
        <img
          src={`/img/svg/about-virtuos-lft-bg.svg`}
          alt="About Virtuos Background Image"
        />
      </div>
      <div className="page-wrap">
        <h2 className="tag">About Virtuos</h2>
        <span className="title-content">
          Virtuos is born in the digital age of Experience Economy (Xonomy)
          building on our AI Ambition and delivering transformational
          opportunities for the enterprises across industry verticals. Our
          Strategic Business—Virtuos Digital (VDC) is a company with 15+ years
          of experience in CX, Digital Strategy & Design, and Digital
          Transformation Consulting
        </span>

        <div className="bigthink">
          {/* <NavLink to={`/nexorama/bigthink/`} className="col-3 item-wrapper wow fadeInDown duration animated" data-wow-duration="500ms" data-wow-delay="300ms"> */}
          <figure style={{ padding: "30px 0" }}>
            <img src={bigthink} alt="bigthink logo" />
          </figure>
          {/* </NavLink> */}

          {/* <div className="heading1">
              <div className="left">
                <p><img src={`/img/svg/oracle-logo.svg`} alt="Oracle" /></p>
                <p><img src={`/img/svg/icons/qualtrics-logo.svg`} alt="Qualtrics" /></p>
                <p><img src={`/img/svg/cxnow-logo.svg`} alt="CXNow" /></p>
              </div>
              <div className="right">
                <p><img src={`/img/svg/icons/novv-logo.svg`} alt="NOVV" style={{ width: '50px' }} /></p>
              </div>
            </div> */}
          {/* <div className="heading2">
              <p>CX.DIGITAL</p>
              <p>TRANSFORMATION</p>
            </div> */}
          {/* <NavLink to={`/vivacis/`} className="col-3 item-wrapper wow fadeInUp duration animated" data-wow-duration="500ms" data-wow-delay="300ms">
            <figure>
              <img src={`/img/svg/icons/vivacis-logo.svg`} alt="Vivacis" />
            </figure>
            <div className="heading1">
              <div className="left">
                <p><img src={`/img/svg/icons/agiloft-logo.svg`} alt="Agiloft" /></p>
                <p><img src={`/img/svg/icons/creatio-logo.svg`} alt="Creatio" /></p>
                <p><img src={`/img/svg/icons/asana-logo.svg`} alt="Asana" /></p>
              </div>
              <div className="right">
                <p><img src={`/img/svg/icons/microsoft-logo.svg`} alt="Microsoft" /></p>
              </div>
            </div>
            <div className="heading2">
              <p>DIGITAL AUTOMATION</p>
              <p>@SPEED</p>
            </div>
          </NavLink>
          <NavLink to={`/veracis/`} className="col-3 item-wrapper wow fadeInDown duration animated" data-wow-duration="500ms" data-wow-delay="300ms">
            <figure>
              <img src={`/img/svg/icons/veracis-logo.svg`} alt="Veracis" />
            </figure>
            <div className="heading1">
              <div className="left">
                <p><img src={`/img/svg/icons/cxdesk-logo.svg`} alt="CXDesk" /></p>
                <p><img src={`/img/svg/icons/freshcx-logo.svg`} alt="FreshCX" /></p>
                <p><img src={`/img/svg/icons/talentare-logo.svg`} alt="Talentare" /></p>
              </div>
              <div className="right">
                <p><img src={`/img/svg/icons/expedience-logo.svg`} alt="Expedience" /></p>
              </div>
            </div>
            <div className="heading2">
              <p>CUSTOMER TRUST</p>
              <p>OPERATIONS</p>
            </div>
          </NavLink>

          <NavLink to="http://www.vedam.com" target="_blank" className="col-3 item-wrapper wow fadeInDown duration animated" data-wow-duration="500ms" data-wow-delay="300ms">
            <figure>
              <img src={`/img/svg/icons/vedam-logo.svg`} alt="Vedam" />
            </figure>
            <div className="heading1">
              <div className="left">
                <p><img src={`/img/svg/icons/commerce-do-logo.svg`} alt="Commerce.do" /></p>
                <p><img src={`/img/svg/icons/experience-do-logo.svg`} alt="Experience.do" /></p>
                <p><img src={`/img/svg/icons/uxmx-logo.svg`} alt="UXMX" style={{ width: '50px' }} /></p>
              </div>
              <div className="right">
                <p><img src={`/img/svg/icons/audacis-logo.svg`} alt="Audacis" /></p>
              </div>
            </div>
            <div className="heading2">
              <p>DIGITAL AGENCY</p>
              <p>MARKETING</p>
            </div>
          </NavLink> */}
        </div>

        <div className="row block2">
          <div className="col-4 item-wrapper">
            <p
              className="left-content wow fadeInDown duration animated"
              data-wow-duration="500ms"
              data-wow-delay="300ms"
            >
              TWO SIDES OF{" "}
              <span className="highlight">INNOVATION AND TRANSFORMATION</span>{" "}
              OF THE SAME COIN.
            </p>
          </div>
          <div
            className="col-8 item-wrapper wow fadeInUp duration animated"
            data-wow-duration="500ms"
            data-wow-delay="300ms"
          >
            <div className="item-block">
              <span className="number">1</span>
              <NavLink to={`/`} className="content-block">
                <h3>INNOVATION</h3>
                <p>
                  Developing New Products in the Age of Experience Economy
                  igniting new AI-Ambition.
                </p>
              </NavLink>
            </div>

            <div className="item-block">
              <NavLink
                target="_blank"
                to={`https://www.vdc.com`}
                className="content-block"
              >
                <h3>TRANSFORMATION</h3>
                <p>
                  Driving Digital Transformation with CRM, Customer Experience
                  (CX) and Hyper Automation
                </p>
              </NavLink>
              <span className="number">2</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About_virtuos;
